const currentTransientRowId = { current: 0 };

/**
 * Helper to generate row IDs when adding a new row on the client side
 *
 * IMPORTANT: We can't use existing state (i.e. rows.length + 1) because it can
 * produce duplicates. For example:
 * 1. Add row A (id = rows.length + 1 = 1)
 * 2. Add row B (id = rows.length + 1 = 2)
 * 3. Remove row A (now rows.length === 1)
 * 4. Add row C (id = rows.length + 1 = 2) -> same as Row B
 */
export const generateTransientRowId = () => {
  currentTransientRowId.current += 1;
  return `transient-row-${currentTransientRowId.current}`;
};
